import React from 'react';
import * as Types from 'pages/Pages/typings';
import _get from 'lodash/get';
import classnames from 'classnames';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Tooltip from '@material-ui/core/Tooltip';
import Switch from '@material-ui/core/Switch';

import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  values: Types.EntityEditFormValues;
  onChange: (field: string, value: any) => void;
}

function JoinPage({ values, onChange }: Props) {
  const classes = useStyles();
  const isSyncManaged = _get(values, 'isSyncManaged');
  const valueReadOnly = _get(values, 'valueReadOnly');

  const handleAllowJoinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('valueReadOnly', !e.target.checked);
  };

  const content = (
    <Card className={classnames(classes.root, { [classes.disabled]: isSyncManaged })}>
      <CardHeader
        title="Allow end users to join a page?"
        subheader="If switched on, end users will be able to join or leave a page by editing the associated attribute on their profile page, or clicking a 'Join' button on the page. If switched off, page members will be fully managed by page editors."
        action={
          <Switch
            checked={!valueReadOnly}
            inputProps={{ 'aria-label': 'join page switch' }}
            onChange={handleAllowJoinChange}
          />
        }
      />
    </Card>
  );

  return isSyncManaged ? (
    <Tooltip
      arrow
      placement="top"
      title="When the associated person attribute has data mapped to it, people will be added and removed from pages automatically, and membership can no longer be managed inside of Sift."
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    maxWidth: 900,
  },
  createPages: {
    display: 'flex',
  },
  disabled: {
    cursor: 'pointer',
    opacity: theme.palette.opacity.thirtyEightPercent,
  },
}));

export default JoinPage;
